// unified diff 解析：给 SOP 提议 / 版本历史的 diff 着色（+ 绿、- 红、@@ 段头）
export type DiffLineType = "add" | "del" | "ctx" | "hunk" | "meta";

export interface DiffLine {
  type: DiffLineType;
  text: string;
}

export function parseUnifiedDiff(diff: string): DiffLine[] {
  if (!diff) return [];
  const lines = diff.replace(/\r\n/g, "\n").split("\n");
  if (lines[lines.length - 1] === "") lines.pop();
  return lines.map((text): DiffLine => {
    if (text.startsWith("+++") || text.startsWith("---") || text.startsWith("Index:") || text.startsWith("====") || text.startsWith("\\"))
      return { type: "meta", text };
    if (text.startsWith("@@")) return { type: "hunk", text };
    if (text.startsWith("+")) return { type: "add", text };
    if (text.startsWith("-")) return { type: "del", text };
    return { type: "ctx", text };
  });
}

export function diffStats(lines: DiffLine[]): { added: number; removed: number } {
  return {
    added: lines.filter((l) => l.type === "add").length,
    removed: lines.filter((l) => l.type === "del").length,
  };
}
